module.exports = __webpack_public_path__ + "static/media/app-bar-login.cd36c38a.svg";